import { render } from "./ContentsBundleIndex.vue?vue&type=template&id=1fda4efc&scoped=true&ts=true"
import script from "./ContentsBundleIndex.vue?vue&type=script&lang=ts"
export * from "./ContentsBundleIndex.vue?vue&type=script&lang=ts"

import "./ContentsBundleIndex.vue?vue&type=style&index=0&id=1fda4efc&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src866133389/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1fda4efc"]])

export default __exports__